import React from 'react';
import { SectionHeading } from '../product/SectionHeading';
type SectionShellProps = {
  id: string;
  title: string;
  subtitle?: string;
  tone?: 'white' | 'warm';
  note?: React.ReactNode;
  children: React.ReactNode;
};

/** Generic company-page section: left-aligned heading, optional review note, then content. */
export function SectionShell({
  id,
  title,
  subtitle,
  tone = 'white',
  note,
  children
}: SectionShellProps) {
  return <section className={`w-full py-20 ${tone === 'warm' ? 'bg-canvas-warm' : 'bg-white'}`} aria-labelledby={id} data-id="element-354" data-mp="2ydfwyujzzp1f">
      <div className="mx-auto max-w-shell px-6" data-id="element-355" data-mp="33fdoec2jxq5g">
        <SectionHeading id={id} title={title} subtitle={subtitle} align="left" data-id="element-356" data-mp="2peufz3u6ci2r" />
        {note && <div className="mt-6 max-w-[620px]" data-id="element-357" data-mp="2ud4gzv2kycwa">{note}</div>}
        <div className="mt-10" data-id="element-358" data-mp="2udnw740uin6m">{children}</div>
      </div>
    </section>;
}